export default ({ request }) => ({
  detailDesignElementsInfoApi (data = {}) {
    return request({
      url: '/digitalCenter/designElementsInfo/detail',
      method: 'post',
      data
    })
  },
  listDesignElementsInfoApi (data = {}) {
    return request({
      url: '/digitalCenter/designElementsInfo/list',
      method: 'post',
      data
    })
  },
  tagListDesignElementsInfoApi (data = {}) {
    return request({
      url: '/digitalCenter/designElementsInfoTag/list',
      method: 'post',
      data
    })
  },
  attributeListDesignElementsInfoApi (data = {}) {
    return request({
      url: '/digitalCenter/designElementsInfoAttribute/list',
      method: 'post',
      data
    })
  },
  saveDesignElementsInfoApi (data = {}) {
    return request({
      url: '/digitalCenter/designElementsInfo/save',
      method: 'post',
      data
    })
  },
  batchAddDesignElementsInfoApi (data = {}) {
    return request({
      url: '/digitalCenter/designElementsInfo/batchAdd',
      method: 'post',
      data
    })
  },
  updateStatusDesignElementsInfoApi (data = {}) {
    return request({
      url: '/digitalCenter/designElementsInfo/del',
      method: 'post',
      data
    })
  }
})
